import DataHandler from './data-handler'

export default DataHandler
